
let config = {
  KEYCLOAK_URL: process.env.KEYCLOAK_URL,
  KEYCLOAK_REALM: process.env.KEYCLOAK_REALM,
  KEYCLOAK_REALM_DOMAIN: process.env.KEYCLOAK_REALM_DOMAIN,
  KEYCLOAK_CLIENT_ID: process.env.KEYCLOAK_CLIENT_ID,
  KEYCLOAK_LOGIN_OPTIONS: {},
  ORGANISATIONS: process.env.ORGANISATIONS,
};

export function initConfig() {
  const overrides = window.ENV;
  if (overrides != null) {
    config = {...config, ...overrides};
  }
}

// sanity ...
initConfig();

export function getConfig(key) {
  const value = config[key];
  if (value == null) {
    console.warn("missing config value:", key);
  }
  return config[key];
}

